/**
 * headingFont.js — carrega sob demanda a fonte de TÍTULO do nicho (D18: só h1/h2).
 *
 * O corpo do painel é fixo (DM Sans, D19) e o título do tema Padrão (Plus Jakarta Sans) já vêm no
 * index.html. As fontes de título dos outros 12 nichos só baixam para quem usa aquele tema — antes
 * eram 23 famílias no index.html para todo mundo.
 */
const PRELOADED = new Set(['DM Sans', 'Plus Jakarta Sans']);
const SYSTEM = /^(system-ui|-apple-system|BlinkMacSystemFont|sans-serif|serif|monospace|Segoe UI|Roboto|Helvetica|Arial|Georgia|Times New Roman)$/i;
const LINK_ID = 'agnd-heading-font';

/** Primeira família de uma pilha CSS ("'Oswald', 'Barlow', sans-serif" → "Oswald"). */
export function firstFontFamily(stack) {
  if (typeof stack !== 'string') return null;
  const first = stack.split(',')[0]?.trim().replace(/^['"]|['"]$/g, '');
  return first || null;
}

/**
 * URL do Google Fonts para a fonte de título, ou null quando não há o que baixar (fonte de
 * sistema ou já carregada pelo index.html). Pesos 400–700 juntos: famílias de peso único
 * (Bebas Neue, Prata) respondem 400 se pedidas só com 600/700 — medido em 2026-09-13.
 */
export function headingFontHref(stack) {
  const family = firstFontFamily(stack);
  if (!family || PRELOADED.has(family) || SYSTEM.test(family)) return null;
  return `https://fonts.googleapis.com/css2?family=${family.replace(/ /g, '+')}:wght@400;500;600;700&display=swap`;
}

/** Garante um único <link> da fonte de título do tema atual. */
export function ensureHeadingFont(stack) {
  if (typeof document === 'undefined') return;
  const href = headingFontHref(stack);
  const existing = document.getElementById(LINK_ID);
  if (!href) { existing?.remove(); return; }
  if (existing?.getAttribute('href') === href) return;
  const link = existing || Object.assign(document.createElement('link'), { id: LINK_ID, rel: 'stylesheet' });
  link.setAttribute('href', href);
  if (!existing) document.head.appendChild(link);
}
